import React, {useState} from "react";
import {Spin} from "antd";
import { serverRequest } from "../../../util/server_request";
import { notifyUser, normalizePhoneNumber, toInternationalPhone } from "../../../util/util";
import { useNavigate } from "react-router-dom";

export const EmployeeNumberFP = () => {
  const navigate = useNavigate();

  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);

  const toggleLoading = () => setLoading((prevState) => !prevState);

  const verifyPhone = () => {
    if (phoneNumber === "" || phoneNumber === null) {
      return notifyUser(
        "error",
        "Please enter phone number!",
        "Validation Error"
      );
    }
    const normalizedPhone = normalizePhoneNumber(phoneNumber);
    toggleLoading();
    serverRequest("POST", "auth/password/forgot", { phone: toInternationalPhone(normalizedPhone) })
      .then((result) => {
        toggleLoading();
        if (result?.success) {
          navigate("/forgot-password/one-time-password", {
            state: { phone: normalizedPhone },
          });
        } else {
          notifyUser("error", result.message, "Error");
        }
      })
      .catch((error) => {
        toggleLoading();
        notifyUser("error", error.message, "Error");
      });
  };

  return (
    <div className="mx-auto mobile-full-width shadow bg-white p-5 rounded login-width">
      <div align="center">
        <p className="lead fw-bold">Forgot Password</p>
        <small>Let’s help you recover your password</small>

        <Spin spinning={loading}>
          <div className="mt-4 w-75 mx-auto mobile-full-width">
            <div className="mb-5">
              <omk-text-field
                label="Phone Number"
                value={phoneNumber}
                type="text"
                onInput={(e) => setPhoneNumber(e.target.value)}
              />
            </div>
            <p className="text-center omk-text-small fw-bold">Need help?</p>
            <p className="text-center omk-text-small text-black-50">
              <i className="bi bi-shield-lock" /> Your information is
              confidential and secure
            </p>
            <button
              className="btn btn-primary mb-4 w-50 mobile-full-width"
              onClick={verifyPhone}
            >
              Continue
            </button>
            <p className="text-center mt-3">
              <a href="/onboard/login" className="fw-bold text-decoration-underline" style={{ color: '#009677' }}>
                Back to Login
              </a>
            </p>
          </div>
        </Spin>
      </div>
    </div>
  );
};
